(ns manage.adset-decision-tree-page.view.header
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Avatar$default" :as Avatar]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Collapse$default" :as Collapse]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/ListSubheader$default" :as ListSubheader]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/system" :refer [styled]]
            ["cron-parser" :refer [CronExpressionParser]]
            ["moment/min/moment-with-locales$default" :as moment]
            ["src/svg/arrows/arrow-clockwise-2.svg$default" :as ArrowClockwise2]
            ["src/svg/files_folders/bin.svg$default" :as Bin]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            ["src/svg/objects/automagic.svg$default" :as Automagic]
            ["src/svg/objects/magic-wand.svg$default" :as MagicWand]
            ["src/svg/wpp/arrows/chevron-right.svg$default" :as ChevronRight]
            ["src/svg/wpp/arrows/trend-ascent.svg$default" :as TrendAscent]
            ["src/svg/wpp/content-actions/archive.svg$default" :as ArchiveIcon]
            ["src/svg/wpp/content-actions/sync.svg$default" :as Sync]
            ["src/svg/wpp/content/iframe.svg$default" :as IFrame]
            ["src/svg/wpp/content/stack.svg$default" :as StackIcon]
            [common.debouncer :as debouncer]
            [common.flags :refer [use-flag]]
            [common.modal.util :refer [with-confirmation-modal]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as adset.q]
            [common.resource.query.adset-activation
             :refer [activation-log-query
                     adset-activation-schedule-mutation
                     adset-activation-schedule-query]]
            [common.resource.query.decision-tree :as queries]
            [common.resource.query.social-settings :as social-settings]
            [common.widgets.input :refer [input]]
            [common.widgets.menu :refer [menu]]
            [goog.object :as gobject]
            [manage.ad-variant.optimization-ocp.view :as optimization-ocp]
            [manage.adset-decision-tree-page.ad-variant-table-ocp.view
             :as ad-variant-table-ocp]
            [manage.adset-decision-tree-page.auto-generate-trackers-ocp.view
             :as auto-generate-trackers-ocp]
            [manage.adset-decision-tree-page.bulk-apply-trackers-ocp.view
             :as bulk-apply-trackers-ocp]
            [manage.adset-decision-tree-page.editor.hooks :refer [use-fit-view]]
            [manage.adset-decision-tree-page.event :as event]
            [manage.adset-decision-tree-page.navigation :as navigation]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.tree-generation-ocp.view
             :as tree-generation-ocp]
            [manage.adset-decision-tree-page.view.common :refer [chip no-max-width-tooltip]]
            [manage.adset-decision-tree-page.view.context :as context]
            [manage.adset-integration-meta-settings.db :as meta-settings-db]
            [manage.adset.hooks :as ah]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-next-sync [expression]
  (try
    (let [interval (.parse CronExpressionParser expression)]
      (.toString (.next interval)))
    (catch :default _
      nil)))

(defhook use-sync-status []
  (let [{{published-decision-tree-id :id} :published}
        (uix/use-context context/decision-trees-context)

        {activation-schedule-query-status :status
         {{sync-paused :paused sync-schedule :schedule} :data} :data}
        (-> (use-subscribe [:url-context])
            (assoc :enabled
                   (some? published-decision-tree-id))
            adset-activation-schedule-query
            use-query)

        {activation-log-query-status :status
         {{[latest-push] :push [latest-pull] :pull} :data} :data}
        (-> (use-subscribe [:url-context])
            (assoc :enabled (not sync-paused))
            activation-log-query
            use-query)

        has-sync? (and latest-push latest-pull)

        next-sync (and (false? sync-paused)
                       (some-> sync-schedule get-next-sync moment .fromNow))

        last-sync-successful? (and (:success latest-pull) (:success latest-push))
        last-sync-unsuccessful? (not last-sync-successful?)]
    {:activation-schedule-query-status activation-schedule-query-status
     :activation-log-query-status activation-log-query-status
     :sync-paused sync-paused
     :sync-schedule sync-schedule
     :has-sync? has-sync?
     :next-sync next-sync
     :latest-push latest-push
     :latest-pull latest-pull
     :last-sync-successful? last-sync-successful?
     :last-sync-unsuccessful? last-sync-unsuccessful?}))

(defui sync-details
  [{{push-created-at :created-at push-success :success} :push
    {pull-created-at :created-at pull-success :success} :pull}]
  ($ Stack {:gap 0.5}
     ($ :div
        ($ Typography "Last push: " (some-> push-created-at moment .fromNow))
        ($ Typography (if push-success "Successful" "Failed")))
     ($ :div
        ($ Typography "Last pull: " (some-> pull-created-at moment .fromNow))
        ($ Typography (if pull-success "Successful" "Failed")))))

(defui sync-status []
  (let [{:keys [activation-log-query-status
                has-sync? next-sync sync-paused
                latest-push latest-pull]} (use-sync-status)

        label (cond
                (not has-sync?) "Not published"
                sync-paused "Sync paused"
                next-sync (str "Next sync " next-sync))]
    (when (= "success" activation-log-query-status)
      ($ Tooltip {:placement "bottom"
                  :title (when has-sync?
                           ($ sync-details {:push latest-push :pull latest-pull}))}
         ($ :span label)))))

(defhook use-last-updated-info [{:keys [status]}]
  {:pre [(#{:published :draft} status)]}
  (let [{{{last-updated-user-name :name} :updated-by-user
          last-updated-at :updated-at} status}
        (uix/use-context context/decision-trees-context)]
    (when (and last-updated-at last-updated-user-name)
      {:user last-updated-user-name
       :updated-at last-updated-at
       :label (case status
                :published "published"
                :draft "edited")})))

(defui decision-tree-last-updated-row [{:keys [user updated-at label]}]
  ($ Typography
     "Last " label ": "
     (-> updated-at moment .fromNow)
     " by "
     ($ Typography {:component "span" :sx #js {:fontWeight 600}}
        user)))

(defui generate-tags-button []
  (let [{is-trees-query-success :is-trees-query-success
         {published-decision-tree-id :id} :published}
        (uix/use-context context/decision-trees-context)

        {:keys [adset-id]} (use-subscribe [:url-context])
        channel (ah/use-channel)]

    (when (and is-trees-query-success
               (some? published-decision-tree-id)
               (#{"display" "video" "ctv"} channel))
      ($ Button {:variant "text"
                 :on-click (fn [^js _event]
                             (rf/dispatch [:export-tags/open-ocp :html-file [adset-id]]))}
         "Generate tags"))))

(defui open-decision-tree-button []
  (let [{{draft-decision-tree-id :id} :draft
         {published-decision-tree-id :id} :published}
        (uix/use-context context/decision-trees-context)
        draft-info (use-last-updated-info {:status :draft})
        published-info (use-last-updated-info {:status :published})
        url-context (use-subscribe [:url-context])
        {create-new-decision-tree :mutate}
        (use-mutation (queries/create-new-decision-tree-mutation url-context))]
    ($ no-max-width-tooltip
       {:title (when (or draft-info published-info)
                 ($ Stack {:gap 0.5}
                    (when draft-info ($ decision-tree-last-updated-row draft-info))
                    (when published-info ($ decision-tree-last-updated-row published-info))))}
       ($ Button {:variant "contained"
                  :on-click (if (and (nil? draft-decision-tree-id)
                                     (nil? published-decision-tree-id))
                              create-new-decision-tree
                              navigation/enter-editor-mode)}
          "Open Decision Tree"))))

(defui sync-button [{:keys [sync-paused channel]}]
  (let [{mutate-adset-activation-schedule :mutate}
        (-> (use-subscribe [:url-context])
            adset-activation-schedule-mutation
            use-mutation)
        [tooltip-open set-tooltip-open] (uix/use-state false)]
    ($ Tooltip
       {:title (str "Stop syncing with "
                    (case channel
                      "meta" "Meta"
                      "tiktok" "TikTok")
                    ". While paused, the platform won't
                     update ad delivery or status. You can resume syncing at any time.")
        :placement "bottom"
        ;; Tooltip needs to be controlled such that it can be hidden immediately when
        ;; the `sync-paused` is true. It also makes sure the tooltip is only visible when
        ;; hovering and `sync-paused` is false.
        :open (and tooltip-open (not sync-paused))
        :onOpen #(set-tooltip-open true)
        :onClose #(set-tooltip-open false)}
       ($ Button
          {:variant "contained"
           :onClick #(mutate-adset-activation-schedule
                      {:paused (not sync-paused)})
           :color "grey"}
          (if sync-paused "Resume Sync" "Pause Sync")))))

(defhook use-discard-draft-menu-item []
  (let [url-context (use-subscribe [:url-context])
        {{draft-decision-tree-id :id} :draft} (uix/use-context context/decision-trees-context)
        {discard-draft :mutate} (use-mutation (queries/discard-draft-decision-tree-mutation
                                               (assoc url-context
                                                      :decision-tree-id draft-decision-tree-id
                                                      :on-success navigation/exit-to-table)))]
    {:label "Discard draft"
     :icon ($ Bin {:width 20 :height 20})
     :on-click #(rf/dispatch [::event/schedule-after-nodes-are-saved discard-draft])
     :disabled? (nil? draft-decision-tree-id)}))

(defui strategy-tab-actions []
  (let [channel (ah/use-channel)
        {{draft-decision-tree-id :id
          has-draft-newer-revisions :has-newer-revisions
          has-draft-archived-variants :has-archived-variants} :draft
         {published-decision-tree-id :id
          has-published-newer-revisions :has-newer-revisions
          has-published-archived-variants :has-archived-variants} :published}
        (uix/use-context context/decision-trees-context)

        {:keys [activation-schedule-query-status sync-paused]} (use-sync-status)

        view-mode (use-subscribe [::sub/view-mode])]
    ($ Stack
       {:gap 1
        :direction "row"
        :alignItems "center"
        :alignSelf "flex-start"}
       (when (or has-draft-newer-revisions
                 (and (nil? draft-decision-tree-id) has-published-newer-revisions))
         ($ chip {:sx #js {:bgcolor "primary.selected"
                           :color "primary.main"}
                  :label "New Versions available"
                  :icon ($ SvgIcon {:component Automagic
                                    :color "primary.main"})}))
       (when (or has-draft-archived-variants
                 (and (nil? draft-decision-tree-id) has-published-archived-variants))
         ($ chip {:color "warning"
                  :label "Archived ad variants in tree"
                  :icon ($ SvgIcon {:component ArchiveIcon
                                    :inheritViewBox true})}))

       (when (and (some? published-decision-tree-id)
                  (#{"meta" "tiktok"} channel))
         ($ sync-status))
       (when (and (some? published-decision-tree-id)
                  (#{"meta" "tiktok"} channel)
                  (= activation-schedule-query-status "success"))
         ($ sync-button {:sync-paused sync-paused
                         :channel channel}))

       ($ generate-tags-button)
       ($ open-decision-tree-button)

       ($ ToggleButtonGroup
          {:value view-mode
           :exclusive true
           :size "small"
           :onChange (fn [_e value] (when value (navigation/change-view-mode value)))}
          ($ ToggleButton
             {:value "table"}
             ($ Icon "reorder"))
          ($ ToggleButton
             {:value "tree"}
             ($ Icon "account_tree"))))))

(defhook use-publish-callback [integration-settings-problems]
  (let [{{draft-decision-tree-id :id} :draft
         {published-decision-tree-id :id} :published} (uix/use-context context/decision-trees-context)
        url-context (use-subscribe [:url-context])

        {publish-decision-tree :mutate}
        (use-mutation (queries/publish-decision-tree-mutation
                       (assoc url-context :decision-tree-id draft-decision-tree-id)))

        {{:keys [test-state]} :data}
        (use-query (adset.q/adset-aco-active-configuration url-context))
        aco-test-running? (= test-state "started")

        publish-after-nodes-are-saved
        (uix/use-callback
         (fn [] (rf/dispatch [::event/schedule-after-nodes-are-saved publish-decision-tree]))
         [publish-decision-tree])]
    (uix/use-callback
     (fn []
       (with-confirmation-modal (seq integration-settings-problems)
         :adset-integration-settings/modal-edit
         {:publish-mode true
          :account-disabled (some? published-decision-tree-id)}
         #(with-confirmation-modal aco-test-running?
            ::optimization-ocp/optimization-publish-warning
            {}
            publish-after-nodes-are-saved)))
     [integration-settings-problems aco-test-running? publish-after-nodes-are-saved published-decision-tree-id])))

(defui upgrade-all-variants-button [props]
  (let [{{draft-decision-tree-id :id} :draft}
        (uix/use-context context/decision-trees-context)

        url-context (use-subscribe [:url-context])

        {upgrade-all-variants :mutate}
        (use-mutation (queries/upgrade-all-variants-mutation
                       (assoc url-context :decision-tree-id draft-decision-tree-id)))]
    ($ Button (merge {:on-click upgrade-all-variants
                      :sx #js {:color "primary.main"}
                      :start-icon ($ SvgIcon {:component ArrowClockwise2})}
                     props)
       "Update all variants")))

(defui remove-archived-ad-variants-button [props]
  (let [{{draft-decision-tree-id :id} :draft}
        (uix/use-context context/decision-trees-context)

        url-context (use-subscribe [:url-context])

        {remove-archived :mutate}
        (use-mutation (queries/remove-archived-ad-variants-mutation
                       (assoc url-context :decision-tree-id draft-decision-tree-id)))]
    ($ Button (merge {:on-click #(remove-archived nil)
                      :variant "contained"
                      :color "warning"
                      :start-icon ($ SvgIcon {:component ArchiveIcon
                                              :inheritViewBox true})}
                     props)
       "Remove archived")))

(def debounce (debouncer/make-debouncer 250))

(defui ad-variant-search-input [props]
  (let [text (use-subscribe [::sub/ad-variant-search-text])
        fit-view (use-fit-view)
        search (uix/use-callback (fn [value]
                                   (rf/dispatch
                                    [::event/update-ad-variant-search
                                     value
                                     fit-view]))
                                 [fit-view])
        debounced-search (uix/use-memo (fn [] (debounce search)) [search])
        on-change (uix/use-callback (fn [^js e]
                                      (let [value (.. e -target -value)]
                                        (debounced-search value)))
                                    [debounced-search])]
    ($ input
       (merge {:defaultValue text
               :onChange on-change
               :placeholder "Search Ad variants or targeting"
               :sx #js {:width "35rem"}
               :icon ($ Icon "search")}
              props))))

(defui ad-variant-search-bar []
  (let [enabled (use-subscribe [::sub/ad-variant-search-enabled])]
    ($ Stack
       {:direction "row"
        :alignItems "center"}
       ($ Collapse
          {:orientation "horizontal"
           :mountOnEnter true
           :unmountOnExit true
           :in enabled}
          ($ ad-variant-search-input
             {:autoFocus true
              :onBlur #(rf/dispatch [::event/enable-ad-variant-search (not enabled)])}))
       (when-not enabled
         ($ Tooltip {:title "Search Ad variants or targeting"}
            ($ IconButton
               {:onClick #(rf/dispatch [::event/enable-ad-variant-search
                                        (not enabled)])}
               ($ Icon "search")))))))

(def styled-list-header
  ((styled ListSubheader)
   (fn [^js props]
     #js {:fontSize (.. props -theme -typography -md)
          :fontWeight 600
          :color (.. props -theme -palette -text -primary)
          :padding "0 8px"
          :height 40})))

(defui tools-menu []
  (let [[anchor-el set-anchor-el] (uix/use-state nil)
        url-context (use-subscribe [:url-context])
        channel (ah/use-channel)
        meta-adset? (= channel "meta")
        aco-enabled? (use-flag :ad-variant-content-optimizing)
        rotation-control-enabled? (use-flag :ad-variant-rotation-control)
        bulk-apply-trackers-enabled? (use-flag :decision-tree-bulk-apply-trackers)
        ad-variant-table-enabled? (use-flag :decision-tree-ad-variant-table)
        auto-generate-trackers-enabled? (use-flag :decision-tree-generate-external-trackers)
        auto-generate-trackers-available? (and auto-generate-trackers-enabled?
                                               meta-adset?
                                               (not ad-variant-table-enabled?))
        {{:keys [test-state]} :data}
        (use-query (adset.q/adset-aco-active-configuration url-context))
        aco-test-running? (= test-state "started")]
    ($ :div
       ($ Button
          {:variant "text"
           :sx #js {:color "text.primary"}
           :startIcon ($ StackIcon)
           :onClick #(set-anchor-el (.-currentTarget %))}
          "Tools")
       ($ Menu
          {:anchorEl anchor-el
           :open (boolean anchor-el)
           :onClose #(set-anchor-el nil)
           :anchorOrigin #js {:vertical "bottom"
                              :horizontal "right"}
           :transformOrigin #js {:vertical "top"
                                 :horizontal "right"}
           :sx (fn [^js theme]
                 #js {".MuiMenu-list" #js {:padding 1
                                           :width "330px"}
                      ".MuiMenuItem-root" #js {:px 1
                                               :py 0.5
                                               :height "unset"
                                               :color "grey.20"
                                               :whiteSpace "pre-wrap"

                                               ".MuiAvatar-root" #js {:width 32
                                                                      :height 32
                                                                      :backgroundColor "grey.80"
                                                                      "& svg *" #js {:fill (gobject/get (.. theme -palette -grey) "20")}}

                                               ".MuiMenuItem-header" #js {:fontWeight 500
                                                                          :color "text.primary"}}
                      ".MuiMenuItem-root:hover" #js {:backgroundColor "primary.selected"
                                                     ".MuiMenuItem-header" #js {:color "primary.main"}}})}
          (when aco-enabled?
            ($ :div
               ($ styled-list-header "Optimization")
               ($ MenuItem {:onClick (fn []
                                       (set-anchor-el nil)
                                       (if aco-test-running?
                                         (rf/dispatch [:ocp/open {:id ::optimization-ocp/toggle-optimization}])
                                         (optimization-ocp/open-delivery-optimization rotation-control-enabled?)))}
                  ($ Avatar
                     ($ TrendAscent))
                  ($ Stack
                     ($ :span.MuiMenuItem-header
                        "Optimizing Delivery")
                     ($ :span
                        (if aco-test-running? "Disable optimization" "Enable optimization")))
                  ($ SvgIcon {:sx #js {:ml "auto"}
                              :component ChevronRight}))))
          ($ Divider)
          ($ styled-list-header "Strategy Generation")
          ($ MenuItem {:onClick (fn []
                                  (set-anchor-el nil)
                                  (rf/dispatch [:ocp/open {:id ::tree-generation-ocp/ocp}]))}
             ($ Avatar
                ($ MagicWand))
             ($ Stack {:sx #js {:overflowX "hidden"}}
                ($ :span.MuiMenuItem-header
                   "Generate Tree")
                ($ :span
                   "Auto-generate from strategy labels in feed"))
             ($ SvgIcon {:sx #js {:ml "auto"}
                         :component ChevronRight}))

          ($ :div
             ($ Divider)
             ($ styled-list-header "Configuration")
             (when-not ad-variant-table-enabled?
               ($ MenuItem {:onClick (fn []
                                       (set-anchor-el nil)
                                       (rf/dispatch [:ocp/open {:id ::bulk-apply-trackers-ocp/ocp}]))}
                  ($ Avatar
                     ($ IFrame))
                  ($ Stack
                     ($ :span.MuiMenuItem-header
                        "Bulk apply Tracker")
                     ($ :span
                        "Set up trackers in a bulk"))
                  ($ SvgIcon {:sx #js {:ml "auto"}
                              :component ChevronRight})))
             (when ad-variant-table-enabled?
               ($ MenuItem {:onClick (fn []
                                       (set-anchor-el nil)
                                       (rf/dispatch [:ocp/open
                                                     {:id ::ad-variant-table-ocp/ad-variant-table}]))}
                  ($ Avatar
                     ($ IFrame))
                  ($ Stack
                     ($ :span.MuiMenuItem-header "Ad Variant Table")
                     ($ :span "Edit trackers per ad variant with CSV support"))
                  ($ SvgIcon {:sx #js {:ml "auto"}
                              :component ChevronRight})))
             (when auto-generate-trackers-available?
               ($ MenuItem {:onClick (fn []
                                       (set-anchor-el nil)
                                       (rf/dispatch [:ocp/open {:id ::auto-generate-trackers-ocp/ocp}]))}
                  ($ Avatar
                     ($ Sync))
                  ($ Stack
                     ($ :span.MuiMenuItem-header
                        "Auto-Generate Trackers")
                     ($ :span
                        "Create CM360 trackers automatically"))
                  ($ SvgIcon {:sx #js {:ml "auto"}}
                     ($ ChevronRight)))))))))

(defui publish-button [{:keys [platform-settings-problems]}]
  (let [publish-callback (use-publish-callback platform-settings-problems)]
    ($ Button {:variant "contained"
               :on-click publish-callback}
       "Publish")))

(defui social-publish-button []
  (let [{:keys [problems]} (meta-settings-db/use-settings-details)]
    ($ publish-button {:platform-settings-problems problems})))

(defui edit-button []
  (let [{{published-decision-tree-id :id} :published} (uix/use-context
                                                       context/decision-trees-context)
        url-context (use-subscribe [:url-context])
        {create-draft-decision-tree :mutate}
        (use-mutation (queries/create-draft-decision-tree-mutation
                       (assoc url-context
                              :on-success navigation/enter-editor-mode
                              :decision-tree-id published-decision-tree-id)))]
    ($ Button {:variant "contained"
               :on-click create-draft-decision-tree}
       "Edit")))

(defui editor-header-actions []
  (let [{:keys [is-editor-readonly]} (uix/use-context context/decision-trees-context)
        has-newer-revisions (use-subscribe [::sub/has-newer-revisions])
        has-archived (use-subscribe [::sub/has-archived-ad-variants-in-tree])
        discard-draft-menu-item (use-discard-draft-menu-item)
        social-adset? (ah/use-is-social-adset?)]
    ($ Stack {:direction "row"
              :alignItems "center"
              :m 1
              :spacing 1}
       ($ ad-variant-search-bar)
       (when-not is-editor-readonly
         ($ :<>
            (when has-newer-revisions
              ($ upgrade-all-variants-button))
            (when has-archived
              ($ remove-archived-ad-variants-button))
            ($ menu {:icon "more_horiz"
                     :items [discard-draft-menu-item]})
            ($ tools-menu)))
       ($ Divider {:orientation "vertical" :flexItem true})
       ($ Button {:variant "text"
                  :sx #js {:color "text.primary"}
                  :onClick #(rf/dispatch [::event/schedule-after-nodes-are-saved
                                          navigation/exit-to-table])}
          "Close")
       (if is-editor-readonly
         ($ edit-button)
         (if social-adset?
           ($ social-publish-button)
           ($ publish-button))))))

(defui saving-indicator []
  (let [saving-status (use-subscribe [::sub/decision-tree-saving-status])]
    (case saving-status
      (:fetching :patch-debounced) ($ CircularProgress {:size 18})
      :success ($ Tooltip {:placement "bottom"
                           :title "The Decision Tree is saved"}
                  ($ Icon {:color "success"} "check"))
      :error ($ Icon {:color "warning"} "warning"))))

(defui automation-paused-alert []
  (let [{{draft-decision-tree-id :id} :draft}
        (uix/use-context context/decision-trees-context)
        automated-activation? (use-flag :automated-activation)
        auto-publish? (social-settings/use-auto-publish)]
    (when (and (some? draft-decision-tree-id) automated-activation? auto-publish?)
      ($ Alert {:severity "warning"
                :icon ($ AlertIcon)
                :sx #js {:width "100%"}}
         ($ AlertTitle "Automation is paused")
         "Automated updates are paused because this Decision Tree has an unpublished draft. Publish or discard it to resume automation."))))

(defui strategy-tab-header []
  (let [{{draft-decision-tree-id :id} :draft}
        (uix/use-context context/decision-trees-context)

        {:keys [next-sync sync-paused last-sync-unsuccessful?]} (use-sync-status)

        auto-publish? (social-settings/use-auto-publish)

        view-mode (use-subscribe [::sub/view-mode])]
    ($ Stack
       (when (and (false? sync-paused) last-sync-unsuccessful?)
         ($ Alert
            {:severity "warning"
             :icon ($ AlertIcon)
             :sx #js {:mb 2}}
            "Last sync failed; next sync attempt is " next-sync "."))

       (when (and (some? draft-decision-tree-id) (not auto-publish?))
         ($ Alert
            {:severity "info"
             :icon ($ Icon "info")
             :sx #js {:mb 2}}
            "You have unsaved changes to your decision tree. Click Open Decision Tree to publish or discard your changes."))

       (when (= view-mode "tree")
         ($ Stack
            {:direction "row"
             :alignItems "center"
             :justifyContent "space-between"
             :sx #js {:py 1}}
            ($ ad-variant-search-input {:icon "search"})
            ($ strategy-tab-actions))))))
